import cx from 'classnames'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonLink from '../../../../components/Buttons/ButtonLink/ButtonLink'
import useScroll from '../../hooks/useScroll'

import './UserMenuBar.scss'

const UserMenuBar = ({
    loading,
    logout,
    isClubMember,
    ticketsRef,
    cinestarClubRef,
    lostCardRef,
    contactInfoRef,
    changePassRef,
    className,
    color,
    isSticky,
    ...props
}) => {
    const intl = useIntl()

    const ticketsScroll = useScroll(ticketsRef)
    const cinestarClubScroll = useScroll(cinestarClubRef)
    const lostCardScroll = useScroll(lostCardRef)
    const contactInfoScroll = useScroll(contactInfoRef)
    const changePassScroll = useScroll(changePassRef)

    const btnClassName = 'px-0 py-1'

    return (
        <Container
            fluid
            className={cx(`user-menu-bar user-menu-bar--${color} position-relative ${'space'}`, className)}
            {...props}
        >
            <div className={`user-menu-bar--content d-flex `}>
                <ButtonLink className={btnClassName} onClick={ticketsScroll}>
                    {intl.formatMessage({ id: 'userProfile.menuBar.ticketAndReservation' })}
                </ButtonLink>
                {isClubMember && (
                    <>
                        <ButtonLink className={btnClassName} onClick={cinestarClubScroll}>
                            {intl.formatMessage({ id: 'userProfile.menuBar.cinestarClub' })}
                        </ButtonLink>

                        <ButtonLink className={btnClassName} onClick={lostCardScroll}>
                            {intl.formatMessage({ id: 'userProfile.menuBar.lostCard' })}
                        </ButtonLink>
                    </>
                )}
                <ButtonLink className={btnClassName} onClick={contactInfoScroll}>
                    {intl.formatMessage({ id: 'userProfile.menuBar.contactInfo' })}
                </ButtonLink>
                <ButtonLink className={btnClassName} onClick={changePassScroll}>
                    {intl.formatMessage({ id: 'userProfile.menuBar.passChange' })}
                </ButtonLink>

                <div className={`user-menu-bar--logout d-flex justify-content-center align-items-center`}>
                    <ButtonLink onClick={logout} disabled={loading} iconLeft={'logout'} className={'p-0'}>
                        {intl.formatMessage({ id: 'buttons.logout' })}
                    </ButtonLink>
                </div>
            </div>
        </Container>
    )
}

export default UserMenuBar
